export default __webpack_public_path__ + "static/media/Bmw s1000rr.fb422ef8.jpg";